import React from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';

import DocumentService from '../../../../../services/document.service';
import CanMassActions from '../../../../../components/list/canMassActions';
import AttachedFile from '../../../../../components/files/attachedFile';
import Select from '../../../../../components/form/niceSelect';
import CheckBox from '../../../../../components/list/grid/checkBox';
// import ChangeAccess from '../../../../../components/modalWindows/changeAccess';
import DragAndDrop from '../../../../../components/form/dragAndDrop';


const StepFiles = ({
                     t,
                     showFiles = true,
                     checked,
                     callback,
                     activeItem,
                     toggleModal,
                     activeModal,
                     upload_name,
                     deleteFiles,
                     onEditSelect,
                     callbackMass,
                     changeAccess,
                     updateChecked,
                     toggleModalMass,
                     activeModalMass,
                   }) => (
  <React.Fragment>
    {/*{activeModal && <ChangeAccess*/}
    {/*toggleModal={toggleModal}*/}
    {/*item={activeItem}*/}
    {/*active={activeModal}*/}
    {/*callback={callback}*/}
    {/*/>}*/}
    {/*{activeModalMass && <ChangeAccess*/}
    {/*toggleModal={toggleModalMass}*/}
    {/*item={{}}*/}
    {/*active={activeModalMass}*/}
    {/*callback={callbackMass}*/}
    {/*/>}*/}
    <div className="document-module">
      <DragAndDrop
        id={upload_name}
        label={
          <p className="btn browsebtn">{t('Or')} <span className="underl pointer">{t('Browse')}</span> {t('To upload')}
          </p>}
        fields={prop => (
          (showFiles && prop.files.length ?
            <div className="DocBox boxs doc-install grid forscrollgrid initial-overflow">
              <div className="tb">
                <div className="boxs docDTable_pres">
                  <div className="boxs docDTable">
                  </div>
                </div>
                <div className="tb-tr tb-upload tb-th">
                  <p className="tb-th_check">
                  </p>
                  <p className="tb-td tb-frst doccol_1" />
                  <p className="tb-td tb-cntr doccol_2">
                    {t('Uploaded')}
                  </p>
                  <p className="tb-td tb-lst doccol_3">
                  </p>
                </div>
                {prop.files.map((file, i) => (
                  <div className="tb-tr tb-upload" key={i}>
                    <p className="tb-th_check tb-td">
                      {/*<CheckBox*/}
                        {/*index={file.id}*/}
                        {/*updateChecked={updateChecked}*/}
                        {/*checked={checked[file.id]}*/}
                      {/*/>*/}
                    </p>
                    <p className="tb-td tb-frst doccol_1">
                      <AttachedFile file={file} onRemove={prop.onRemove} upload />
                    </p>
                    <p className="tb-td tb-cntr doccol_2">
                      {`${file.uploadingPc} %`}
                    </p>
                    <div className="inl-tbl tb-td tb-lst doccol_3">

                    </div>
                  </div>
                ))}
              </div>
            </div> : '')
        )}
      />
    </div>
  </React.Fragment>
);

StepFiles.propTypes = {
  t: PropTypes.func.isRequired,
  callbackMass: PropTypes.func.isRequired,
  toggleModalMass: PropTypes.func.isRequired,
};

export default StepFiles;



// WEBPACK FOOTER //
// ./src/views/modules/documents/install/stepFiles/StepFiles.jsx